module.exports = __webpack_public_path__ + "static/media/roman-calculator.04b1c4a8.jpg";